import React, { useMemo } from 'react'
import { Form, Alert } from 'react-bootstrap'
import { FaStarOfLife } from 'react-icons/fa'
import '../../../screens/CreditReportById/CreditReportById.css'

import './FormInput.css'
interface FormInputWithAlertProps {
  label?: string
  value: string
  setValue: (event: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  validationFunction: (value: string) => boolean
  validationMessage: string
  className?: string
  autoFocus?: boolean
  required?: boolean
}

const FormInputWithAlert: React.FC<FormInputWithAlertProps> = ({
  label,
  value,
  setValue,
  placeholder,
  validationFunction,
  validationMessage,
  className,
  autoFocus,
  required,
}) => {
  return (
    <Form.Group
      className={className}
      controlId="KYCForm.ControlInput2"
      style={{ maxWidth: '430px' }}
    >
      <Form.Control
        type="input"
        value={value}
        autoFocus={autoFocus}
        onChange={setValue}
        className="custom-input"
        onKeyPress={(e) => {
          if (!/[0-9]/.test(e.key)) {
            e.preventDefault()
          }
        }}
        placeholder={placeholder}
      />
      {value !== '' && !validationFunction(value) ? (
        <Alert variant="danger" transition={false}>
          {validationMessage}
        </Alert>
      ) : null}
    </Form.Group>
  )
}

export default FormInputWithAlert
